import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import FormInputSwitch, { IFormInputSwitchProps } from './FormInputSwitch'

const TwoColumnFormInput: React.FC<IFormInputSwitchProps> = ({
  input,
  onChange,
  onEntered,
}) => {
  return (
    <Row style={{ marginTop: '0.5rem', marginBottom: '0.5rem', alignItems: 'flex-end' }}>
      <Col xs={3}>
        <Form.Label>{input.title}</Form.Label>
      </Col>
      <Col>
        <FormInputSwitch input={input} onChange={onChange} onEntered={onEntered} />
      </Col>
    </Row>
  )
}
export default TwoColumnFormInput
